/// <amd-module name="TFS/Admin/Groups/Pivots/Permissions/Components/PermissionsPivot" />
import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { getPermissionsPivotModule } from "../Redux/PermissionsPivotModule";
import { ConnectedPermissionPivotInitializer } from "./PermissionsPivotInitializer";

export class PermissionsPivot extends VssComponent<IPivotProps> {
    constructor(props: IPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <DynamicModuleLoader modules={[getPermissionsPivotModule()]}>
                <ConnectedPermissionPivotInitializer />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-permissions-pivot", PermissionsPivot);
